<script lang="ts" setup>
const props = defineProps<{
  title?: string
  googleMapsQuery: string
  label: string
}>()

const googleUrl = `https://www.google.com/maps/search/?q=${props.googleMapsQuery}, Switzerland`
</script>

<template>
  <SidebarSection>
    <h2 v-if="title" v-animate="{ animation: 'vertical-reveal' }" class="title">{{ title }}</h2>
    <NuxtLink
      v-if="googleMapsQuery && label"
      v-animate="{ animation: 'vertical-reveal' }"
      :to="googleUrl"
      target="_blank"
      class="google-maps-link text-small"
    >
      <div v-html="label" />
      <Icon name="pin" />
    </NuxtLink>

    <div v-else-if="label" v-animate="{ animation: 'vertical-reveal' }" class="text-small">
      <div v-html="label" />

      <Icon name="pin" />
    </div>
  </SidebarSection>
</template>

<style lang="scss" scoped>
.title {
  margin-bottom: 30px;

  @include f-21;
  &:last-child {
    margin-bottom: 0;
  }
}

.google-maps-link,
p {
  width: 100%;
  margin: 0;

  display: grid;
  grid-template-columns: 1fr 30px;
  gap: 10px;
  align-items: center;

  color: var(--c-textlink);
}

:deep(svg) {
  width: 18px;
  height: auto;
}
</style>
